export default __webpack_public_path__ + "static/media/health_care.9b479e84.jpg";